import { useState, useEffect } from 'react'

const TIEMPO_WARNING = 2000

const useWarning = (warnings, name) => {
  const [show, setShow] = useState(false)
  const [warning, setWarning] = useState('')

  useEffect(() => {
    if (warnings) {
      const hayWarning = Object.keys(warnings).length > 0
      const msj = hayWarning ? warnings[name] : ''
      setWarning(msj)

      if (msj !== warning) {
        if (msj !== '') {
          setShow(true)
          setTimeout(() => setShow(false), TIEMPO_WARNING)
        } else {
          setShow(false)
        }
      }
    }
  }, [name, warning, warnings])

  const ShowWarning = () => {
    if (show) {
      return (
        <div className="alert alert-warning mt-1" role="alert">
          {warning}
        </div>
      )
    } else {
      return <></>
    }
  }

  return { ShowWarning, hayWarning: warning !== '' }
}

export default useWarning
